module.exports = __webpack_public_path__ + "static/media/instagramLogo.9cba4898.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Contact/Assets/instagramLogo.svg
// module id = 499
// module chunks = 1